export default __webpack_public_path__ + "static/media/salida.6c3ec308.PNG";